
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M1.62 31.61h36.77v7.32H1.62zM27 31.66v7.13M13 38.79v-7.13M29.25 26.17a14.26 14.26 0 10-18.58-.07M5.02 31.56l5.57-5.37h18.82l5.57 5.37M6 14.93h28"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-linejoin":"round","stroke-width":"2","d":"M20.46 26.4l6.21-11.79M13.33 14.61l6.08 11.55M26.67 14.61L20 1.93l-6.67 12.68M26.67 14.61l4.83 9.18M31.01 6.35l-4.34 8.26M8.49 23.81l4.84-9.2M13.33 14.61L8.78 5.96"}})])
          )
        }
      }
    